//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class DataIntervalTag{
	public id:number;
	public clientId:number;
	public siteId:number=0;
	public deviceId:number;
	public begin:number;
	public end:number|null=null;
	public benchHeightSize:number=0;
	public benchSeamSize:number|null=null;
	public materialType:string="";
	public truckLoadCount:number=0;
	public truckMaterialDensity:number|null=null;
	public comments:string="";
	public benchSeam:string="";
}

export namespace DataIntervalTag{
	export const meta=new ModelMeta<keyof Props>(
		"DataIntervalTag",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "clientId",
				type: "int",
				decorators: {
					index: true
				},
				index: true,
				notNull: true
			},{
				name: "siteId",
				type: "int",
				decorators: {},
				default: 0,
				optional: true,
				notNull: true
			},{
				name: "deviceId",
				type: "int",
				decorators: {
					index: true
				},
				index: true,
				notNull: true
			},{
				name: "begin",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "end",
				type: "int",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "benchHeightSize",
				type: "number",
				decorators: {},
				default: 0,
				optional: true,
				notNull: true
			},{
				name: "benchSeamSize",
				type: "number",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "materialType",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			},{
				name: "truckLoadCount",
				type: "int",
				decorators: {},
				default: 0,
				optional: true,
				notNull: true
			},{
				name: "truckMaterialDensity",
				type: "number",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "comments",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			},{
				name: "benchSeam",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		clientId:number;
		siteId?:number;
		deviceId:number;
		begin:number;
		end?:number|null;
		benchHeightSize?:number;
		benchSeamSize?:number|null;
		materialType?:string;
		truckLoadCount?:number;
		truckMaterialDensity?:number|null;
		comments?:string;
		benchSeam?:string;
	}


	meta.generateRest("data-interval-tag",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		clientId:number;
		siteId?:number;
		deviceId:number;
		begin:number;
		end?:number|null;
		benchHeightSize?:number;
		benchSeamSize?:number|null;
		materialType?:string;
		truckLoadCount?:number;
		truckMaterialDensity?:number|null;
		comments?:string;
		benchSeam?:string;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		clientId:number;
		siteId?:number;
		deviceId:number;
		begin:number;
		end?:number|null;
		benchHeightSize?:number;
		benchSeamSize?:number|null;
		materialType?:string;
		truckLoadCount?:number;
		truckMaterialDensity?:number|null;
		comments?:string;
		benchSeam?:string;
	}

	namespace body{

		interface WritableProps{
			clientId:number;
			siteId?:number;
			deviceId:number;
			begin:number;
			end?:number|null;
			benchHeightSize?:number;
			benchSeamSize?:number|null;
			materialType?:string;
			truckLoadCount?:number;
			truckMaterialDensity?:number|null;
			comments?:string;
			benchSeam?:string;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
